import { makeStyles } from '@mui/styles';
// import { palette } from '@livable/saas-react-components';

const useStyles = makeStyles({
  addCustomBilling: {
    padding: '32px'
  },
  addCustomBillingControllWrapper: {
    marginTop: '16px'
  },
  addCustomBillingControll: {
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'flex-start',
    '& .MuiRadio-root': {
      top: '-1px',
      paddingTop: '0'
    },
    '&:not(:first-child)': {
      marginTop: '12px'
    }
  },
  addCustomBillingSettings: {
    // marginTop: '32px',
  },
  addCustomBillingSetting: {
    '&:not(:first-child)': {
      marginTop: '32px'
    }
  },
  addCustomBillingSettingTitle: {
    marginBottom: '16px'
  }
});
export default useStyles;